'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _newArray2 = require('./_internal/_newArray');

var _newArray3 = _interopRequireDefault(_newArray2);

var _ternary2 = require('./_internal/_ternary');

var _ternary3 = _interopRequireDefault(_ternary2);

var _INT_TWO = require('./_constants/INT_TWO');

var _INT_TWO2 = _interopRequireDefault(_INT_TWO);

var _INT_THREE = require('./_constants/INT_THREE');

var _INT_THREE2 = _interopRequireDefault(_INT_THREE);

var _call = require('./call');

var _call2 = _interopRequireDefault(_call);

var _cast = require('./cast');

var _cast2 = _interopRequireDefault(_cast);

var _compose = require('./compose');

var _compose2 = _interopRequireDefault(_compose);

var _executeWith = require('./executeWith');

var _executeWith2 = _interopRequireDefault(_executeWith);

var _fillBy = require('./fillBy');

var _fillBy2 = _interopRequireDefault(_fillBy);

var _invoke = require('./invoke');

var _invoke2 = _interopRequireDefault(_invoke);

var _isFunction = require('./isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _reverse = require('./reverse');

var _reverse2 = _interopRequireDefault(_reverse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns function which returns value if value is not a function.
 *
 * @module toFunction
 * @func
 * @since 1.0.0
 * @param {*} value
 * @return {function}
 * @example
 *
 *     toFunction(3); //=> () => 3
 *     toFunction(() => 1); //=> () => 1
 */

var fillByR = (0, _reverse2.default)(_fillBy2.default, _INT_TWO2.default);
var fillByVal = fillByR((0, _newArray3.default)(_INT_THREE2.default));
var invokeCast = (0, _compose2.default)(_invoke2.default, _cast2.default);
var executeTernary = (0, _executeWith2.default)(_ternary3.default, _cast2.default, invokeCast, _isFunction2.default);
var callExecuteTernary = (0, _call2.default)(executeTernary);
var toFunction = (0, _compose2.default)(callExecuteTernary, fillByVal);

exports.default = toFunction;